import {
  adCardCollection,
  adCardSetupCollection,
  controllerCollection,
} from "../../config/collectionsConfig";

export const GetADHistory = () => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    // make async call to the database
    try {
      dispatch({ type: "LOAD_ADHISTORY" });
      const adcardslist = [];
      const firestore = getFirestore();
      firestore
        .collection(adCardCollection)
        .where("businessId", "==", getState().profile.profile.id)
        .orderBy("start_date", "desc")
        .get()
        .then((adcards) => {
          if (adcards.size > 0) {
            adcards.forEach((ts) => {
              const adcl = { ...ts.data(), servingToday: false, id: ts.id };
              if (ts.data().completed) {
                adcl.sda = 0;
              }
              adcardslist.push(adcl);
            });
          } else {
            dispatch({
              type: "GET_ADHISTORY",
              payload: [],
            });
          }
          console.log("dispatched");
          dispatch({
            type: "GET_ADHISTORY",
            payload: adcardslist,
          });
        })
        .catch((e) => {
          dispatch({ type: "GET_ADHISTORY_ERROR", payload: e });
        });
    } catch (e) {
      dispatch({ type: "GET_ADHISTORY_ERROR", payload: e });
    }
  };
};

export const GetController = (regionid = null) => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    // make async call to the database
    try {
      dispatch({ type: "LOAD_CONTROLLER" });
      const firestore = getFirestore();
      firestore
        .collection(controllerCollection)
        .where(
          "systemAccountId",
          "==",
          regionid === null ? getState().profile.region.id : regionid
        )
        .limit(1)
        .get()
        .then((ccs) => {
          const controllers = [];
          ccs.forEach((ts) => {
            controllers.push({ ...ts.data(), id: ts.id });
          });
          if (controllers.length > 0) {
            dispatch({
              type: "GET_CONTROLLER",
              payload: controllers[0],
            });
          } else {
            dispatch({
              type: "GET_CONTROLLER_ERROR",
              payload: "Controller Not Found",
            });
          }
        })
        .catch((e) => {
          dispatch({ type: "GET_CONTROLLER_ERROR", payload: e });
        });
    } catch (e) {
      dispatch({ type: "GET_CONTROLLER_ERROR", payload: e });
    }
  };
};

export const GetAD = (adcardid) => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    // make async call to the database
    try {
      dispatch({ type: "LOAD_ADHISTORY" });
      const firestore = getFirestore();
      firestore
        .collection(adCardCollection)
        .doc(adcardid)
        .get()
        .then((adcard) => {
          const adcl = {
            ...adcard.data(),
            servingToday: false,
            id: adcard.id,
            adsetup: [],
            adsetupTS: new Map(),
            adsetupCM: new Map(),
            adsetupSP: new Map(),
          };
          if (adcard.data() !== undefined) {
            if (!adcard.data().completed || adcard.data().status > -1) {
              //turn -1 to 0 later
              firestore
                .collection(adCardSetupCollection)
                .where("adCardID", "==", adcard.id)
                .get()
                .then((adcardsetups) => {
                  adcardsetups.forEach((adcs) => {
                    if (
                      !adcard.data().completed &&
                      adcs.data().activeForDate &&
                      !adcl.servingToday
                    ) {
                      adcl.servingToday = true;
                    }
                    if (adcard.data().status > -1) {
                      //turn -1 to 0 later
                      const map = new Map(entries(adcs.data()));
                      Array.from(map.keys()).forEach((key) => {
                        const keyarray = key.split("-");
                        if (keyarray.length === 3) {
                          adcl.adsetup.push({
                            cm: keyarray[0],
                            ts: keyarray[1],
                            sp: keyarray[2],
                            value: map.get(key),
                          });
                          console.log("ADCL");
                          console.log(adcl.adsetup);
                        }

                        //console.log(adcl.adsetupCM.get("dfsafaswe12134das"));
                      });
                      console.log("TASCPD");
                      console.log(adcl.tascpd[0]);
                      const temptascpd = Object.values(adcl.tascpd);
                      adcl.tascpd = temptascpd;
                      dispatch({
                        type: "GET_ADCARD",
                        payload: adcl,
                      });
                    }
                  });
                });
            } else {
              adcl.sda = 0;
              dispatch({
                type: "GET_ADCARD",
                payload: adcl,
              });
            }
          }
          //adcardslists.data().push(adcl);
          // window.alert(adcl.adsetup.length);
        })
        .catch((e) => {
          dispatch({ type: "GET_ADCARD_ERROR", payload: e });
        });
    } catch (e) {
      dispatch({ type: "GET_ADCARD_ERROR", payload: e });
    }
  };
};

function* entries(obj) {
  for (let key in obj) yield [key, obj[key]];
}
